import React, { useState } from 'react';
import ButtonOptions from '../../../../components/NovoSistema/ButtonOptions';
import ButtonsGeneric from '../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../components/NovoSistema/ContainerSection';
import HeaderButtons from '../../../../components/NovoSistema/HeaderButtons';
import InputText from '../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function CadastroDeUsuarioAdd() {
  const [internalOption, setInternalOption] = useState('');
  return (
    <div>
      <ContainerSection>
        <h3>Cadastrar</h3>
        <WrapperInputsNewSystem>
          <InputText title="Nome" id="Nome" widthPercentage="100%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Email" id="Email" widthPercentage="100%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Senha" id="Senha" widthPercentage="100%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputText title="Confirmação de Senha" id="ConfirmacaoDeSenha" widthPercentage="80%" />
          <ButtonsGeneric>
            <button className="success">Mostrar Senha</button>
          </ButtonsGeneric>
        </WrapperInputsNewSystem>
        <p>Modo de Contratação</p>
        <HeaderButtons>
          <ButtonOptions
            buttonName="CLT"
            border="#333F50"
            active={internalOption === 'CLT' ? true : false}
            yourFunction={() => setInternalOption('CLT')}
          />
          <ButtonOptions
            buttonName="PJ"
            border="#333F50"
            active={internalOption === 'PJ' ? true : false}
            yourFunction={() => setInternalOption('PJ')}
          />
        </HeaderButtons>
        {internalOption === 'CLT' && (
          <WrapperInputsNewSystem>
            <InputText title="CPF" id="CPF" widthPercentage="90%" />
          </WrapperInputsNewSystem>
        )}
        {internalOption === 'PJ' && (
          <WrapperInputsNewSystem>
            <InputText title="Nome da Empresa" id="NomeDaEmpresa" widthPercentage="40%" />
            <InputText title="CNPJ" id="CNPJ" widthPercentage="40%" />
          </WrapperInputsNewSystem>
        )}
        <WrapperInputsNewSystem>
          <SelectAndOptions
            title="Empresa"
            id="Empresa"
            optionsArray={['', 'SPA - Silva e Pelaquim Associados']}
            widthPercentage="30%"
          />
        </WrapperInputsNewSystem>
        <ButtonsGeneric>
          <button className="success">Salvar</button>
        </ButtonsGeneric>
      </ContainerSection>
    </div>
  );
}
